// @flow
/** @jsx jsx */

import { useCallback } from 'react';

import { jsx } from '@emotion/core';

import type { Node } from 'react';

const KeydownPropagationBarrier = ({
  children,
  className,
}: {
  children: Node,
  // allows usage of CSS prop
  className?: string,
}) => {
  const stopPropagation = useCallback(event => {
    event.stopPropagation();
  }, []);

  return (
    <div className={className} onKeyDown={stopPropagation} role="presentation">
      {children}
    </div>
  );
};

export default KeydownPropagationBarrier;
